import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useProducts} from '../hooks/useProducts.ts';

export const ReloadRecordsButton = () => {

    const {reloadRecords} = useProducts();
    return (
        <Box mx='xs'>
            <ReloadButton onClick={() => reloadRecords()}/>
        </Box>
    );
};
